export default function createServerMigrationReducer(
  state = { error: "", success: "", processing: false },
  action
) {
  switch (action.type) {
    case "CREATE_MIGRATION_SUCCESS":
      return { ...state, ...{ success: action.success } };

    case "CREATE_MIGRATION_ERROR":
      return { ...state, ...{ error: action.error } };

    case "CREATE_MIGRATION_PROCESSING":
      return { ...state, ...{ processing: action.processing } };

    default:
      return state;
  }
}
